import type { ArticleEntity, SchemaRef } from '../core/types'

export function buildSchemaArticle(options: {
  type?: 'Article' | 'BlogPosting' | 'NewsArticle'
  id?: string
  headline: string
  description?: string
  imageId?: string
  datePublished?: string
  dateModified?: string
  isPartOf?: SchemaRef
  mainEntityOfPage?: SchemaRef
  publisher?: SchemaRef
}): ArticleEntity {
  return {
    '@type': options.type ?? 'BlogPosting',
    ...(options.id ? { '@id': options.id } : {}),
    headline: options.headline,
    ...(options.description ? { description: options.description } : {}),
    ...(options.imageId ? { image: { '@id': options.imageId } } : {}),
    ...(options.datePublished ? { datePublished: options.datePublished } : {}),
    ...(options.dateModified ? { dateModified: options.dateModified } : {}),
    ...(options.isPartOf ? { isPartOf: options.isPartOf } : {}),
    ...(options.mainEntityOfPage ? { mainEntityOfPage: options.mainEntityOfPage } : {}),
    ...(options.publisher ? { publisher: options.publisher } : {})
  }
}
